<template>
  <ais-instant-search :search-client="searchClient" :index-name="assetIndex">
    <ais-configure :hitsPerPage="12" />

    <section class="relative bg-dark-gradient">
      <div class="mx-auto max-w-4xl px-4 py-24 text-center sm:px-6 lg:px-8 lg:py-32">
        <slot name="hero"></slot>

        <div v-if="!trialMember"
          class="border-[10px] shadow-md-dark border-white/10 mt-6 mb-2 max-w-md mx-auto rounded-lg">
          <ais-search-box v-model="query" class="search_page__search_form--dark !shadow-md-dark"
            placeholder="Search all assets" />
        </div>
      </div>
    </section>

    <section>
      <div v-if="query" class="page--container">
        <div class="my-6 sm:w-5/6 mx-auto sm:flex sm:justify-between sm:items-center">
          <nav class=" flex items-center flex-wrap">
            <p class="mb-0 mr-2 uppercase">Filter by file type:</p>
            <ais-refinement-list attribute="kind" :sort-by="['count:desc', 'name']" :class-names="{
              'ais-RefinementList': 'inline_refinement_list',
            }" />
          </nav>

          <ais-stats v-if="query"></ais-stats>
        </div>

        <ais-state-results class="bg-white sm:w-5/6 mx-auto">
          <template v-slot="{ state: { query }, results: { hits } }">
            <ais-hits v-if="hits.length > 0">
              <template v-slot="{ items }" class="my-6">
                <div v-for="item in items" :key="item.objectID">
                  <div class="search_result">
                    <h3 class="search_result--title">
                      <a :href="'/asset-download?id=' + item.assetId">
                        <ais-highlight :hit="item" attribute="title"></ais-highlight>
                      </a>
                    </h3>
                    <p v-if="item.related.length" class="mb-0">
                      Located in: <a v-for="related in item.related" :key="related.url" :href="related.url"><em
                          v-html="related.title"></em></a>
                    </p>
                  </div>
                </div>
              </template>
            </ais-hits>

            <p v-else class="text-center my-6 border border-yellow-400 bg-yellow-100 p-4 text-lg">
              There are no
              results found for: "{{ query }}".</p>
            <ais-pagination class="mb-8" :padding="5" v-if="hits.length > 0" />
          </template>
        </ais-state-results>
      </div>
    </section>
  </ais-instant-search>
</template>

<script>
import { ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY, ASSET_INDEX } from '@js/config/algolia.js';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import {
  AisInstantSearch,
  AisConfigure,
  AisStats,
  AisPoweredBy,
  AisSearchBox,
  AisHits,
  AisHighlight,
  AisStateResults,
  AisPagination,
  AisRefinementList,
} from 'vue-instantsearch/vue3/es'

export default {

  props: {
    searchQuery: {
      required: false,
      type: String,
      default: ''
    },
    trialMember: {
      required: true,
      type: Boolean
    }
  },

  components: {
    AisInstantSearch,
    AisConfigure,
    AisStats,
    AisPoweredBy,
    AisSearchBox,
    AisHits,
    AisHighlight,
    AisStateResults,
    AisPagination,
    AisRefinementList,
  },

  data() {
    return {
      searchClient: algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY),
      assetIndex: ASSET_INDEX,
      query: this.searchQuery
    }
  }
}
</script>
